module.exports = __webpack_public_path__ + "static/RUdeskSlide3-4e458b9c864f1cb639859fd7d222ff85.png";